'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AccessibleFormat = require('./AccessibleFormat');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AccessibleFormat).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/AccessibleFormat/index.js
// module id = 1086
// module chunks = 1